// JS files
require('@glidejs/glide')
require('./js/main.js')

// SCSS
import '@glidejs/glide/src/assets/sass/glide.core.scss'
import './sass/main.scss'
